import {
  GET_TRASLADOS_HISTORIAL,
  GET_TRASLADOS_REFERENTES,
  GET_TRASLADOS_SITUACION_ACTUAL,
  GET_TRASLADOS_SITUACION_PERIODO,
  GET_TRASLADOS_PENDIENTES,
  BUSCAR_TRASLADOS,
  GET_MOTIVOS_ANULACION_TRASLADO,
  GET_OBSERVACIONES_PT,
  GET_MOTIVOS_RECHAZO_PT,
  GET_MOTIVOS_NEGATIVO_PT,
  FETCH_AGENCIAS,
  TOGGLE_AGENCIA_STATUS,
  GET_TRASLADOS_SEARCH_MODEL,
} from "../actions/traslados";
import { didInvalidate } from "../utils/errorHandler";

const slice = () => ({
  isFetching: false,
  didInvalidate: false,
  data: [],
});

const INITIAL_STATE = {
  searchModel: {
    isFetching: false,
    didInvalidate: false,
    data: null,
  },
  historial: {
    isFetching: false,
    didInvalidate: false,
    data: {
      traslados: [],
      cantTraslados: 0,
      valorUmbralCantTraslados: null,
    },
  },
  referentes: slice(),
  situacionActual: slice(),
  situacionPeriodo: slice(),
  referentes: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  pendientes: {
    isFetching: false,
    didInvalidate: false,
    data: {},
  },
  busqueda: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  motivosAnulacion: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  observacionesTramo: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  motivosRechazoPT: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  motivosNegativoPT: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  agencias: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
};

const traslados = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GET_TRASLADOS_HISTORIAL}_PENDING`:
      return {
        ...state,
        historial: { ...state.historial, isFetching: true, didInvalidate: false },
      };
    case `${GET_TRASLADOS_HISTORIAL}_FULFILLED`: {
      const payload = action.payload.data;
      const normalizedData = Array.isArray(payload)
        ? {
            traslados: payload,
            cantTraslados: payload.length,
            valorUmbralCantTraslados: null,
          }
        : {
            traslados: payload?.traslados || [],
            cantTraslados: payload?.cantTraslados ?? (payload?.traslados?.length || 0),
            valorUmbralCantTraslados: payload?.valorUmbralCantTraslados ?? null,
          };

      return {
        ...state,
        historial: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: normalizedData,
        },
      };
    }
    case `${GET_TRASLADOS_HISTORIAL}_REJECTED`:
      return {
        ...state,
        historial: { ...state.historial, isFetching: false, didInvalidate: true },
      };

    case `${GET_TRASLADOS_REFERENTES}_PENDING`:
      return {
        ...state,
        referentes: { ...state.referentes, isFetching: true, didInvalidate: false },
      };
    case `${GET_TRASLADOS_REFERENTES}_FULFILLED`:
      return {
        ...state,
        referentes: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || [],
        },
      };
    case `${GET_TRASLADOS_REFERENTES}_REJECTED`:
      return {
        ...state,
        referentes: { ...state.referentes, isFetching: false, didInvalidate: true },
      };

    case `${GET_TRASLADOS_SITUACION_ACTUAL}_PENDING`:
      return {
        ...state,
        situacionActual: {
          ...state.situacionActual,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_TRASLADOS_SITUACION_ACTUAL}_FULFILLED`:
      return {
        ...state,
        situacionActual: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || [],
        },
      };
    case `${GET_TRASLADOS_SITUACION_ACTUAL}_REJECTED`:
      return {
        ...state,
        situacionActual: {
          ...state.situacionActual,
          isFetching: false,
          didInvalidate: true,
        },
      };

    case `${GET_TRASLADOS_SITUACION_PERIODO}_PENDING`:
      return {
        ...state,
        situacionPeriodo: {
          ...state.situacionPeriodo,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_TRASLADOS_PENDIENTES}_PENDING`:
      return {
        ...state,
        pendientes: {
          ...state.pendientes,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_TRASLADOS_SITUACION_PERIODO}_FULFILLED`:
      return {
        ...state,
        situacionPeriodo: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || [],
        },
      }

    case `${GET_TRASLADOS_PENDIENTES}_FULFILLED`:
      return {
        ...state,
        pendientes: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || {},
        },
      };
    case `${GET_TRASLADOS_PENDIENTES}_REJECTED`:
      return {
        ...state,
        pendientes: {
          ...state.pendientes,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${BUSCAR_TRASLADOS}_PENDING`:
      return {
        ...state,
        busqueda: {
          ...state.busqueda,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${BUSCAR_TRASLADOS}_FULFILLED`:
      return {
        ...state,
        busqueda: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || [],
        },
      };
    case `${GET_TRASLADOS_SITUACION_PERIODO}_REJECTED`:
      return {
        ...state,
        situacionPeriodo: {
          ...state.situacionPeriodo,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${BUSCAR_TRASLADOS}_REJECTED`:
      return {
        ...state,
        busqueda: {
          ...state.busqueda,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_MOTIVOS_ANULACION_TRASLADO}_PENDING`:
      return {
        ...state,
        motivosAnulacion: {
          ...state.motivosAnulacion,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_MOTIVOS_ANULACION_TRASLADO}_FULFILLED`:
      return {
        ...state,
        motivosAnulacion: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || [],
        },
      };
    case `${GET_MOTIVOS_ANULACION_TRASLADO}_REJECTED`:
      return {
        ...state,
        motivosAnulacion: {
          ...state.motivosAnulacion,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_OBSERVACIONES_PT}_PENDING`:
      return {
        ...state,
        observacionesTramo: {
          ...state.observacionesTramo,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_OBSERVACIONES_PT}_FULFILLED`:
      return {
        ...state,
        observacionesTramo: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || [],
        },
      };
    case `${GET_OBSERVACIONES_PT}_REJECTED`:
      return {
        ...state,
        observacionesTramo: {
          ...state.observacionesTramo,
          isFetching: false,
          didInvalidate: true,
        },
      };

    case `${GET_MOTIVOS_RECHAZO_PT}_PENDING`:
      return {
        ...state,
        motivosRechazoPT: {
          ...state.motivosRechazoPT,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_MOTIVOS_RECHAZO_PT}_FULFILLED`:
      return {
        ...state,
        motivosRechazoPT: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || [],
        },
      };
    case `${GET_MOTIVOS_RECHAZO_PT}_REJECTED`:
      return {
        ...state,
        motivosRechazoPT: {
          ...state.motivosRechazoPT,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_MOTIVOS_NEGATIVO_PT}_PENDING`:
      return {
        ...state,
        motivosNegativoPT: {
          ...state.motivosNegativoPT,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_MOTIVOS_NEGATIVO_PT}_FULFILLED`:
      return {
        ...state,
        motivosNegativoPT: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || [],
        },
      };
    case `${GET_MOTIVOS_NEGATIVO_PT}_REJECTED`:
      return {
        ...state,
        motivosNegativoPT: {
          ...state.motivosNegativoPT,
          isFetching: false,
          didInvalidate: true,
        },
      };

    case `${FETCH_AGENCIAS}_PENDING`:
      return {
        ...state,
        agencias: {
          ...state.agencias,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${FETCH_AGENCIAS}_FULFILLED`:
      return {
        ...state,
        agencias: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || [],
        },
      };
    case `${FETCH_AGENCIAS}_REJECTED`:
      return {
        ...state,
        agencias: {
          ...state.agencias,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${TOGGLE_AGENCIA_STATUS}_FULFILLED`:
      return {
        ...state,
        agencias: {
          ...state.agencias,
          data: action.payload.data.success ? 
                state.agencias.data.map(a => a.idAgencia === action.payload.data.idAgencia ? { ...a, activo: action.payload.data.activo } : a) 
                : state.agencias.data
        }
      };

    case `${GET_TRASLADOS_SEARCH_MODEL}_PENDING`:
      return {
        ...state,
        searchModel: {
          ...state.searchModel,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_TRASLADOS_SEARCH_MODEL}_FULFILLED`:
      return {
        ...state,
        searchModel: {
          isFetching: false,
          didInvalidate: didInvalidate(action),
          data: action.payload.data || null,
        },
      };
    case `${GET_TRASLADOS_SEARCH_MODEL}_REJECTED`:
      return {
        ...state,
        searchModel: {
          ...state.searchModel,
          isFetching: false,
          didInvalidate: true,
        },
      };

    default:
      return state;
  }
};

export default traslados;
